export default class DesignTeamUsersSearch {
  constructor(opts) {
    let $target = $("[data-search='results']");
    $target.html(opts.html)
  }
}
